// Types
import type { TTableHeaders } from '~/misc/v-table/types';
import type { TTriggerFilter } from '~/modules/opportunities/automated-email/outbox/types';
import { EListingStatusId } from '~/misc/listings/types';

const TABLE_HEADERS: TTableHeaders = [
  '',
  'Recipient',
  'Reason for sending',
  'Subject & Email Preview',
  'Sending in',
  '',
];

const TRIGGER_FILTERS: TTriggerFilter[] = [
  { id: 'all', label: 'All', value: null },
  { id: 'market-success', label: 'Market success', value: 'market-success' },
  { id: 'reduced', label: 'Reduced', value: 'reduced' },
  { id: 'withdrawn', label: 'Withdrawn', value: 'withdrawn' },
];

const LISTING_STATUS_ID_TO_EVENT_LABEL: Record<number, string> = {
  [EListingStatusId.ON_MARKET]: 'On Market',
  [EListingStatusId.UNDER_OFFER]: 'Under Offer',
  [EListingStatusId.LET]: 'Let',
  [EListingStatusId.SOLD]: 'Sold',
  [EListingStatusId.FALLEN_THROUGH]: 'Fallen Through',
  [EListingStatusId.REDUCED]: 'Reduced',
  [EListingStatusId.OFF_MARKET]: 'Off Market',
  [EListingStatusId.WITHDRAWN]: 'Withdrawn',
  [EListingStatusId.SSTC]: 'SSTC',
  [EListingStatusId.LET_AGREED]: 'Let Agreed',
};

export {
  TABLE_HEADERS,
  TRIGGER_FILTERS,
  LISTING_STATUS_ID_TO_EVENT_LABEL,
};
